var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"father",staticClass:"not-found"},[_c('img',{attrs:{"src":"/pic_not_found_01.png","alt":"404"}}),_c('h1',[_vm._v("这是什么地方？")])])
}
var staticRenderFns = []

export { render, staticRenderFns }